import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/jeu',
      component: () => import('../components/JeuComponent.vue'),
    },
    {
      path: '/bilan',
      component: () => import('../components/BilanComponent.vue')
    }
  ]
})

export default router
